interface Step {
  id: number;
  internalName: string;
  friendlyName: string;
}

export type ContractOccurrence =
  | ContractOccurrenceCommon
  | ContractOccurrenceStep
  | ContractOccurrenceItem;

interface ContractOccurrenceCommon {
  id: number;
  createdAt: string;
  ipAddress: string;
  logType: ContractsActionsLogsType;
  statusChangeReason?: string;
  user?: User;
  contractItem?: ContractItem;
  currentStep?: Step;
  nextStep?: Step;
  account?: Account;
}

interface ContractOccurrenceStep extends ContractOccurrenceCommon {
  currentStep: Step;
}

export interface ContractOccurrenceItem extends ContractOccurrenceCommon {
  contractItem: ContractItem;
}

interface Account {
  id: number;
  fullName: string;
}

interface ContractItem {
  id: number;
  operation: Operation;
  line: Line;
  offerPrice: OfferPrice;
  inventory?: Inventory[];
}

interface Inventory {
  serialType: string;
  serialNumber: string;
  product: Product;
}

interface Product {
  name: string;
}

interface Line {
  id: number;
  number: string;
}

interface OfferPrice {
  id: number;
  price: string;
  offer: Offer;
}

interface Offer {
  id: number;
  combo: string;
  plan: Plan;
}

interface Plan {
  id: number;
  name: string;
  carrier: Operation;
}

interface Operation {
  id: number;
  name: string;
}

interface User {
  id: number;
  fullName: string;
  email: string;
}

export enum ContractsActionsLogsType {
  CREATED = "CREATED",
  CREATED_BY_OFFER = "CREATED_BY_OFFER",
  STATUS_CHANGED = "STATUS_CHANGED",
  DELETED = "DELETED",
  AUTO_CLOSE = "AUTO_CLOSE",
  ACCOUNT_ADDED = "ACCOUNT_ADDED",
  ITEM_ADDED = "ITEM_ADDED",
  ITEM_REMOVED = "ITEM_REMOVED",
  INSTALLMENTS_CALCULATED = "INSTALLMENTS_CALCULATED",
  SHIPPING_UPDATED = "SHIPPING_UPDATED",
  PAYMENT_REQUEST_UPDATED = "PAYMENT_REQUEST_UPDATED",
  SIGNATURES_ADDED = "SIGNATURES_ADDED",
  SIGNATURES_UPDATED = "SIGNATURES_UPDATED",
  UPDATE_SIGNATURE_METHOD = "UPDATE_SIGNATURE_METHOD",
  RESEND_SIGNATURES = "RESEND_SIGNATURES",
  STATUS_CHANGED_BY_DIGITAL_SIGNATURE = "STATUS_CHANGED_BY_DIGITAL_SIGNATURE",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  TIMED_OUT = "TIMED_OUT",
  MODIFIED = "MODIFIED"
}

export const ContractsActionsLogsTypeMessage: Record<
  ContractsActionsLogsType,
  string
> = {
  [ContractsActionsLogsType.CREATED]: "Criado",
  [ContractsActionsLogsType.CREATED_BY_OFFER]: "Criado no book de benefícios",
  [ContractsActionsLogsType.STATUS_CHANGED]: "Estado alterado",
  [ContractsActionsLogsType.DELETED]: "Removido",
  [ContractsActionsLogsType.AUTO_CLOSE]: "Concluído",
  [ContractsActionsLogsType.ACCOUNT_ADDED]: "Cooperado adicionado",
  [ContractsActionsLogsType.ITEM_ADDED]: "Item adicionado",
  [ContractsActionsLogsType.ITEM_REMOVED]: "Item removido",
  [ContractsActionsLogsType.INSTALLMENTS_CALCULATED]: "Valor atualizado",
  [ContractsActionsLogsType.SHIPPING_UPDATED]: "Frete atualizado",
  [ContractsActionsLogsType.PAYMENT_REQUEST_UPDATED]:
    "Pagamento da adesão confirmado",
  [ContractsActionsLogsType.SIGNATURES_ADDED]:
    "Assinatura(s) digital(ais) adicionada(s)",
  [ContractsActionsLogsType.SIGNATURES_UPDATED]:
    "Assinatura(s) digital(ais) atualizada(s)",
  [ContractsActionsLogsType.UPDATE_SIGNATURE_METHOD]:
    "Método de assinatura atualizado",
  [ContractsActionsLogsType.RESEND_SIGNATURES]: "Assinaturas reenviadas",
  [ContractsActionsLogsType.STATUS_CHANGED_BY_DIGITAL_SIGNATURE]:
    "Estado alterado por assinatura(s)",
  [ContractsActionsLogsType.DOCUMENT_UPLOADED]: "Documento enviado",
  [ContractsActionsLogsType.TIMED_OUT]: "Expirado",
  [ContractsActionsLogsType.MODIFIED]: "Alterado"
};

export const ContractsActionsLogsTypeDotColor: Record<
  ContractsActionsLogsType,
  string
> = {
  [ContractsActionsLogsType.CREATED]: "green",
  [ContractsActionsLogsType.CREATED_BY_OFFER]: "green",
  [ContractsActionsLogsType.STATUS_CHANGED]: "green",
  [ContractsActionsLogsType.DELETED]: "red",
  [ContractsActionsLogsType.AUTO_CLOSE]: "green",
  [ContractsActionsLogsType.ACCOUNT_ADDED]: "blue",
  [ContractsActionsLogsType.ITEM_ADDED]: "blue",
  [ContractsActionsLogsType.ITEM_REMOVED]: "red",
  [ContractsActionsLogsType.INSTALLMENTS_CALCULATED]: "blue",
  [ContractsActionsLogsType.SHIPPING_UPDATED]: "blue",
  [ContractsActionsLogsType.PAYMENT_REQUEST_UPDATED]: "blue",
  [ContractsActionsLogsType.SIGNATURES_ADDED]: "blue",
  [ContractsActionsLogsType.SIGNATURES_UPDATED]: "blue",
  [ContractsActionsLogsType.UPDATE_SIGNATURE_METHOD]: "blue",
  [ContractsActionsLogsType.RESEND_SIGNATURES]: "blue",
  [ContractsActionsLogsType.STATUS_CHANGED_BY_DIGITAL_SIGNATURE]: "green",
  [ContractsActionsLogsType.DOCUMENT_UPLOADED]: "blue",
  [ContractsActionsLogsType.TIMED_OUT]: "red",
  [ContractsActionsLogsType.MODIFIED]: "blue"
};
